//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    mixins: [],
    props: {
        educations: Object
    },
    mounted () {
    },
    computed: {

    },
    methods: {
    }
}
